module.exports = __webpack_public_path__ + "static/media/landing-kitty13.c5a86ea3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/landing-kitty13.svg
// module id = 126
// module chunks = 0